"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentPlanToJSON = exports.PaymentPlanFromJSONTyped = exports.PaymentPlanFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function PaymentPlanFromJSON(json) {
    return PaymentPlanFromJSONTyped(json, false);
}
exports.PaymentPlanFromJSON = PaymentPlanFromJSON;
function PaymentPlanFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'checkDate': !(0, runtime_1.exists)(json, 'checkDate') ? undefined : json['checkDate'],
        'paymentEvents': !(0, runtime_1.exists)(json, 'paymentEvents') ? undefined : (json['paymentEvents'].map(_1.PaymentPlanPaymentEventsFromJSON)),
    };
}
exports.PaymentPlanFromJSONTyped = PaymentPlanFromJSONTyped;
function PaymentPlanToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'checkDate': value.checkDate,
        'paymentEvents': value.paymentEvents === undefined ? undefined : (value.paymentEvents.map(_1.PaymentPlanPaymentEventsToJSON)),
    };
}
exports.PaymentPlanToJSON = PaymentPlanToJSON;
//# sourceMappingURL=PaymentPlan.js.map